export enum RewardType {
    Pet = 1,
    Mount = 2,
    Quest = 3,
    Toy = 4,
    Cosmetic = 5,
    Armor = 6,
    Weapon = 7,
    Achievement = 8,
    Item = 9,
    Illusion = 10,
    Currency = 11,
    Reputation = 12,
    XpQuest = 13,
    Recipe = 14,
    Spell = 15,
    Decor = 16,
    Transmog = 100,
    AccountQuest = 101,
    CharacterTrackingQuest = 102,
    InstanceSpecial = 1000,
    SetSpecial = 1001,
}
